// EditorLoadingOverlay.jsx
// Loading overlay component for editor initialization and syncing

import React from 'react';
import {Box, CircularProgress, Stack, Typography} from '@mui/material';

/**
 * Loading overlay for editor
 * Displays during connection establishment and document syncing
 *
 * @param {Object} props
 * @param {boolean} props.isLoading - Whether to show loading overlay
 * @param {string} props.loadingStage - Current loading stage ('connecting' | 'syncing')
 */
export default function EditorLoadingOverlay({isLoading, loadingStage}) {
    if (!isLoading) return null;

    const loadingMessage = loadingStage === 'connecting'
        ? 'Establishing secure connection...'
        : 'Loading latest document version...';

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 1)',
                backdropFilter: 'blur(2px)',
                zIndex: 999,
            }}
        >
            <Stack spacing={2} alignItems="center">
                <CircularProgress size={40}/>
                <Typography variant="body2" color="text.secondary">
                    {loadingMessage}
                </Typography>
            </Stack>
        </Box>
    );
}

